var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderOpened(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".canvas{fill: none; opacity: 0;}.light-yellow-10{fill: #996f00; opacity: 0.1;}.light-yellow-25{fill: #996f00; opacity: 0.25;}.light-yellow{fill: #996f00; opacity: 1;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconLightFolderOpened") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "canvas",
    className: "canvas"
  }, /*#__PURE__*/React.createElement("path", {
    className: "canvas",
    d: "M16,16H0V0H16Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "level-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "light-yellow-10",
    d: "M13.5,3.5v2h-5l-1,1h-5l-2,6V2.5h5l1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "light-yellow-25",
    d: "M8.5,5.5h7l-2,7H.5l2-6h5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "light-yellow",
    d: "M15.408,5H14V3.5L13.5,3H6.707l-.853-.854L5.5,2H.5L0,2.5v10l.5.5H13.541l.483-.371,1.868-7ZM1,3H5.293l.853.854L6.5,4H13V5H8.475l-.354.146L7.268,6H2.475L2,6.342,1,9.421Zm12.157,9H1.168L2.835,7h4.64l.353-.146L8.682,6h6.076Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "light-yellow-25",
    d: "M14,12.5H13V6h1Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpened);
export default __webpack_public_path__ + "static/media/FolderOpened.8a14b0cdeb388e66320ecbdbbe6c18c8.svg";
export { ForwardRef as ReactComponent };